export const routes = {
  login: '/login',
  auth_redirect_callback: '/okta/callback',
  acute_physical_therapist: '/acute',
  accounting: '/accounting/*',
  billing_tool: '/billing-tool/*',
  hinge_select: '/hinge-select/*',
  roi: '/roi/*',
  roi_menu: '/roi',
  eligibility: '/eligibility',
  member_auth: '/member-auth/:uuid',
  member_data: '/member-data/*',
  member_data_services: '/member-data-services/*',
  other: '/not-found',
};
